module.exports = __webpack_public_path__ + "static/media/zcdt_Mytg.5374d5f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/zcdt_Mytg.png
// module id = 1882
// module chunks = 0 1